import { useFormikContext } from 'formik';
import React from 'react';
import { SupportedHostApps } from 'renderer/features/products-page/schemas/products.schemas';
import { MenuItem, TextField } from '@mui/material';
import _ from 'lodash';
import { PurchaseOptions } from '../schemas/purchase.schemas';

interface HostAppsDropdownProps {
  supportedHostApplications: SupportedHostApps;
}

const HostAppsDropdown: React.FC<HostAppsDropdownProps> = ({
  supportedHostApplications,
}) => {
  const { values, setFieldValue, errors, touched } =
    useFormikContext<PurchaseOptions>();

  const hostAppIndex = supportedHostApplications.findIndex((app) =>
    _.isEqual(app, values.hostApplication),
  );

  return (
    <TextField
      id="host-app"
      label="Host Application"
      name="host-app"
      size="small"
      // required
      fullWidth
      select
      value={hostAppIndex >= 0 ? `${hostAppIndex}` : ''}
      onChange={(e) => {
        const index = parseInt(e.target.value, 10);
        const newApp = supportedHostApplications[index];
        if (newApp) {
          setFieldValue('hostApplication', newApp);
        }
      }}
      // choose option based on key input
      onKeyUp={(e) => {
        const index = supportedHostApplications.findIndex((app) =>
          _.startsWith(app.displayName.toLowerCase(), e.key.toLowerCase()),
        );
        const newApp = supportedHostApplications[index];
        if (newApp) {
          setFieldValue('hostApplication', newApp);
        }
      }}
      error={touched.hostApplication && !!errors.hostApplication}
      helperText={touched.hostApplication && (errors.hostApplication as string)}
    >
      {supportedHostApplications.map(({ displayName, id, version }, i) => (
        <MenuItem key={`${id}-${displayName}-${version}`} value={`${i}`}>
          {displayName}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default HostAppsDropdown;
